import { Input } from '@designsystem/stories/02-atoms/Input';
import {
  Formfield,
  FormfieldProps,
} from '@designsystem/stories/03-molecules/Formfield';

export interface TextFieldProps extends FormfieldProps {
  /**
   * Whether the inserted value is invalid.
   */
  isInvalid?: boolean;
  /**
   * A placeholder text displayed when the input field is empty.
   */
  placeholder?: string;
  /**
   * Type of the input.
   */
  type?:
    | 'number'
    | 'search'
    | 'text'
    | 'email'
    | 'date'
    | 'time'
    | 'datetime-local'
    | 'password'
    | 'textarea';
  /**
   * The ID of the input field.
   */
  id?: string;
  /**
   * The name of the input field.
   */
  name?: string;
  /**
   * The value of the input field.
   */
  value?: string;
  /**
   * Whether the input field is disabled.
   */
  isDisabled?: boolean;
  /**
   * The onChange handler.
   */
  onChange?: (value: string) => void;
  /**
   * The onClick handler.
   */
  onClick?: () => void;
  /**
   * The minimum length of the input field.
   */
  minLength?: number;
  /**
   * The maximum length the input field.
   */
  maxLength?: number;
  /**
   * The maximum value, e.g. the latest date of a date input.
   */
  max?: string;
}

const TextField = ({
  label,
  labelRequired,
  description,
  errorMessage,
  isRequired = false,
  isInvalid,
  isDisabled,
  ...props
}: TextFieldProps) => {
  return (
    <Formfield
      htmlFor={props?.id}
      label={label}
      description={description}
      isRequired={isRequired}
      labelRequired={labelRequired}
      errorMessage={errorMessage}
    >
      <Input
        required={isRequired}
        error={isInvalid}
        disabled={isDisabled}
        {...props}
      />
    </Formfield>
  );
};

export default TextField;
